import "./MiniBook.css";

const MiniBook = ({ book, onClick, isShared = false, isRecommended = false, showWishlist = false, isWishlisted = false, onToggleWishlist }) => (
  <div
    className={`mini-book${isShared ? " mini-book-shared" : ""}`}
    onClick={() => onClick(book.id)}
  >
    <div className="mini-book-cover" style={{ background: book.bg }}>
      {book.cover
        ? <img src={book.cover} alt={book.title} />
        : <span className="mini-book-emoji">{book.emoji || "📖"}</span>
      }
      {isRecommended && <div className="recommend-sun">☀️</div>}
      {showWishlist && (
        <button
          className={`wishlist-btn${isWishlisted ? " active" : ""}`}
          onClick={(e) => { e.stopPropagation(); if (onToggleWishlist) onToggleWishlist(book); }}
          title="읽고 싶은 책에 담기"
        >🔖</button>
      )}
    </div>
    <div className="mini-book-label">
      <div className="mini-book-label-title">{book.title}</div>
      <div className="mini-book-label-author">{book.author}</div>
    </div>
    <div className="mini-tooltip">
      <div className="mini-tooltip-title">{book.title}</div>
      <div className="mini-tooltip-author">{book.author}</div>
      {book.registeredDate && (
        <div className="mini-tooltip-date">📅 {book.registeredDate}</div>
      )}
      {isShared && <div className="mini-tooltip-shared">✨ 함께 읽은 책</div>}
    </div>
  </div>
);

export default MiniBook;
